module.exports = __webpack_public_path__ + "img/clothing198.7c568548.jpg";